<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  name?: string | null
  email?: string | null
  size?: 'small' | 'medium'
}

const props = withDefaults(defineProps<Props>(), {
  name: null,
  email: null,
  size: 'medium',
})

const initials = computed(() => {
  const source = (props.name?.trim() || props.email?.trim() || '').trim()
  if (!source) return '?'
  const parts = source.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  }
  return source.slice(0, 2).toUpperCase()
})
</script>

<template>
  <div class="user-avatar" :class="`user-avatar--${size}`" aria-hidden="true">
    {{ initials }}
  </div>
</template>

<style scoped>
.user-avatar {
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--green-muted);
  color: var(--action-blue-contrast);
  display: grid;
  place-items: center;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.user-avatar--small {
  width: 24px;
  height: 24px;
  font-size: 0.7rem;
}
.user-avatar--medium {
  width: 32px;
  height: 32px;
  font-size: 0.8rem;
}
</style>
